export const NOTIFICATION_CHANNEL = {
  EMAIL: 'EMAIL',
  WHATSAPP: 'WHATSAPP',
  PHONE: 'PHONE',
  SOCIAL_MEDIA: 'SOCIAL_MEDIA'
}
